<a class="file cursor-text">
  <i class="icon ic-file-16"></i>
  <span>{{ fileName }}</span>
</a>
